import { useProfile } from "./ProfileContext";

export function ProfileActiveJobDisplay(props) {
	let [profile] = useProfile();
	return <div {...props}>
		{profile?.job != null && <div style={{float:"left"}} className="my-3">
			{profile.job.name}
			{" "}
			{profile?.rentalMode && "(Rentals)"}
		</div>}
		{profile?.job == null && <div style={{float:"left"}} className="my-3">
			{ profile?.rentalMode && <span>
				Rental Mode
			</span>}
			{ profile != null && profile.job == null && (!profile.rentalMode) && <span>
				No active job
			</span>}
			&nbsp; {/* force similar space whether in rental mode or not */}
		</div>}
	</div>;
}